<h2 mat-dialog-title>Edit Time</h2>
<mat-dialog-content>
  <mat-form-field>
    <input matInput placeholder="Time Reported" [(ngModel)]="record.timeReportedString">
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-raised-button color="primary" [mat-dialog-close]="true">Submit</button>  
  <button mat-raised-button mat-dialog-close>Dismiss</button>
</mat-dialog-actions>